var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import http, { Q } from '@http';
import { observable, action, runInAction, computed, reaction } from 'mobx';
import { PredefinePriority } from '@common/enums/base';
import Cookies from "js-cookie";
import { getLocationId, getClientCode } from "@common/utils/index";
var PreferredTimeCaptureStore = /** @class */ (function () {
    function PreferredTimeCaptureStore(parent) {
        this.isStep4 = false;
        this.clientCode = getClientCode(Cookies.get("clientCode"));
        this.clientId = Cookies.get("clientId");
        this.slaStartTime = null;
        this.slaEndTime = null;
        this.formattedSLAEndTime = null;
        this.timeZone = null;
        this.firstTimes = [];
        this.secondTimes = [];
        this.thirdTimes = [];
        this.isProvidePreferredScheduleTime = null;
        this.currentOptionId = null;
        this.isRequiredOptions = false;
        this.isRequired1st = false;
        this.isRequired2nd = false;
        this.isRequired3rd = false;
        this.parent = parent;
        this.init();
    }
    PreferredTimeCaptureStore.prototype.bundlePriority = function () {
        return (this.parent.priority);
    };
    PreferredTimeCaptureStore.prototype.init = function () {
        var _this = this;
        reaction(function () {
            return {
                priority: _this.bundlePriority()
            };
        }, function (result) {
            if (result.priority && _this.isStep4) {
                _this.render();
            }
        });
    };
    PreferredTimeCaptureStore.prototype.render = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.getIsEnableResidentPreferredSchedule();
                        this.getScheduleSLATime();
                        return [4 /*yield*/, this.parent.getRegionScript()];
                    case 1:
                        _a.sent();
                        this.parent.canServiceScheduleOptimization();
                        return [2 /*return*/];
                }
            });
        });
    };
    PreferredTimeCaptureStore.prototype.setIsStep4 = function (v) {
        this.isStep4 = v;
    };
    Object.defineProperty(PreferredTimeCaptureStore.prototype, "isPreferredTimeCapturePriority", {
        get: function () {
            var showPriorityIds = [
                PredefinePriority.Critical,
                PredefinePriority.Emergency,
                PredefinePriority.RoutineStandardService,
                PredefinePriority.RoutineExpeditedService,
                PredefinePriority.NextAvailableService
            ];
            var result = showPriorityIds.indexOf(this.parent.priority) !== -1;
            return result;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PreferredTimeCaptureStore.prototype, "isCritical", {
        get: function () {
            return this.parent.priority === PredefinePriority.Critical;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PreferredTimeCaptureStore.prototype, "isShowAvailability", {
        get: function () {
            return this.isEnableResidentPreferredSchedule &&
                ((!this.parent.isInHouseTechnician &&
                    this.isPreferredTimeCapturePriority &&
                    !this.parent.isProcare &&
                    !this.parent.isAutoSchedule) || this.parent.urgentIHTNoRecommendSpecificProcess);
        },
        enumerable: false,
        configurable: true
    });
    PreferredTimeCaptureStore.prototype.clearPreferredTimeCaptureData = function () {
        this.firstTimes = null;
        this.secondTimes = null;
        this.thirdTimes = null;
        this.isRequiredOptions = false;
        this.isRequired1st = false;
        this.isRequired2nd = false;
        this.isRequired3rd = false;
        this.currentOptionId = null;
        this.isProvidePreferredScheduleTime = null;
    };
    PreferredTimeCaptureStore.prototype.getPreferredTimeCaptureModel = function () {
        var first = this.getTimes(this.firstTimes);
        var second = this.getTimes(this.secondTimes);
        var third = this.getTimes(this.thirdTimes);
        return {
            priorityId: this.parent.priority,
            firstPreferredStartTime: first ? first[0].format('YYYY-MM-DD HH:mm A') : null,
            firstPreferredEndTime: first ? first[1].format('YYYY-MM-DD HH:mm A') : null,
            secondPreferredStartTime: second ? second[0].format('YYYY-MM-DD HH:mm A') : null,
            secondPreferredEndTime: second ? second[1].format('YYYY-MM-DD HH:mm A') : null,
            thirdPreferredStartTime: third ? third[0].format('YYYY-MM-DD HH:mm A') : null,
            thirdPreferredEndTime: third ? third[1].format('YYYY-MM-DD HH:mm A') : null,
            haveResidentPreferredSchedule: this.isEnableResidentPreferredSchedule,
            isProvidePreferredScheduleTime: this.isProvidePreferredScheduleTime,
            isExistSLA: true,
            sLAStartTime: this.slaStartTime,
            sLAEndTime: this.slaEndTime,
            isEnableResidentPreferredSchedule: this.isEnableResidentPreferredSchedule,
            isPreferredTimeCapturePriority: this.isPreferredTimeCapturePriority,
            isCritical: this.isCritical,
            isRequiredOptions: this.isRequiredOptions,
            isRequired1st: this.isRequired1st,
            isRequired2nd: this.isRequired2nd,
            isRequired3rd: this.isRequired3rd,
        };
    };
    PreferredTimeCaptureStore.prototype.getTimes = function (times) {
        if (times && times.length > 0) {
            return times.map(function (v) {
                return v;
            }).slice();
        }
        return null;
    };
    PreferredTimeCaptureStore.prototype.getScheduleSLATime = function () {
        return __awaiter(this, void 0, void 0, function () {
            var params;
            var _this = this;
            return __generator(this, function (_a) {
                params = {
                    locationId: getLocationId(),
                    clientId: this.clientId,
                    priorityId: this.parent.priority
                };
                return [2 /*return*/, this.api().getScheduleSLATime(params).then(function (rawData) {
                        if (rawData) {
                            runInAction(function () {
                                _this.slaStartTime = rawData.slaStartTime;
                                _this.slaEndTime = rawData.slaEndTime;
                                _this.formattedSLAEndTime = rawData.formattedSLAEndTime;
                                _this.timeZone = rawData.timeZone;
                            });
                        }
                    })];
            });
        });
    };
    PreferredTimeCaptureStore.prototype.getIsEnableResidentPreferredSchedule = function () {
        return __awaiter(this, void 0, void 0, function () {
            var params;
            var _this = this;
            return __generator(this, function (_a) {
                params = {
                    locationId: getLocationId()
                };
                return [2 /*return*/, this.api().getIsEnableResidentPreferredSchedule(params).then(function (rawData) {
                        if (rawData) {
                            runInAction(function () {
                                _this.isEnableResidentPreferredSchedule = rawData;
                            });
                        }
                    })];
            });
        });
    };
    PreferredTimeCaptureStore.prototype.setTimes = function (times, type) {
        switch (type) {
            case TimesType["1st"]:
                this.firstTimes = times;
                this.validateFirstTimes();
                break;
            case TimesType["2nd"]:
                this.secondTimes = times;
                this.validateSecondTimes();
                break;
            case TimesType["3rd"]:
                this.thirdTimes = times;
                this.validateThirdTimes();
                break;
        }
    };
    PreferredTimeCaptureStore.prototype.setOptions = function (item) {
        this.currentOptionId = item.id;
        if (item.id === 1) {
            this.isProvidePreferredScheduleTime = true;
        }
        else {
            this.isProvidePreferredScheduleTime = false;
        }
        this.validateOptions();
    };
    PreferredTimeCaptureStore.prototype.validate = function () {
        this.validateOptions();
        if (this.isProvidePreferredScheduleTime) {
            this.validateFirstTimes();
            this.validateSecondTimes();
            this.validateThirdTimes();
        }
    };
    PreferredTimeCaptureStore.prototype.validateOptions = function () {
        if (this.isProvidePreferredScheduleTime === null) {
            this.isRequiredOptions = true;
        }
        else {
            this.isRequiredOptions = false;
        }
    };
    PreferredTimeCaptureStore.prototype.validateFirstTimes = function () {
        if (this.firstTimes.length === 0) {
            this.isRequired1st = true;
        }
        else {
            this.isRequired1st = false;
        }
    };
    PreferredTimeCaptureStore.prototype.validateSecondTimes = function () {
        if (this.secondTimes.length === 0) {
            this.isRequired2nd = true;
        }
        else {
            this.isRequired2nd = false;
        }
    };
    PreferredTimeCaptureStore.prototype.validateThirdTimes = function () {
        if (this.thirdTimes.length === 0) {
            this.isRequired3rd = true;
        }
        else {
            this.isRequired3rd = false;
        }
    };
    PreferredTimeCaptureStore.prototype.api = function () {
        return {
            getIsEnableResidentPreferredSchedule: function (params) { return Q(http.get("RSP/ResidentPreferredSchedule/IsEnableResidentPreferredSchedule", {
                params: params
            })); },
            getScheduleSLATime: function (params) { return Q(http.get("RSP/ResidentPreferredSchedule/GetScheduleSLATime", {
                params: params
            })); }
        };
    };
    __decorate([
        observable
    ], PreferredTimeCaptureStore.prototype, "isStep4", void 0);
    __decorate([
        action
    ], PreferredTimeCaptureStore.prototype, "setIsStep4", null);
    __decorate([
        computed
    ], PreferredTimeCaptureStore.prototype, "isPreferredTimeCapturePriority", null);
    __decorate([
        computed
    ], PreferredTimeCaptureStore.prototype, "isCritical", null);
    __decorate([
        computed
    ], PreferredTimeCaptureStore.prototype, "isShowAvailability", null);
    __decorate([
        action
    ], PreferredTimeCaptureStore.prototype, "clearPreferredTimeCaptureData", null);
    __decorate([
        action
    ], PreferredTimeCaptureStore.prototype, "getPreferredTimeCaptureModel", null);
    __decorate([
        observable
    ], PreferredTimeCaptureStore.prototype, "clientCode", void 0);
    __decorate([
        observable
    ], PreferredTimeCaptureStore.prototype, "clientId", void 0);
    __decorate([
        observable
    ], PreferredTimeCaptureStore.prototype, "slaStartTime", void 0);
    __decorate([
        observable
    ], PreferredTimeCaptureStore.prototype, "slaEndTime", void 0);
    __decorate([
        observable
    ], PreferredTimeCaptureStore.prototype, "formattedSLAEndTime", void 0);
    __decorate([
        observable
    ], PreferredTimeCaptureStore.prototype, "timeZone", void 0);
    __decorate([
        action
    ], PreferredTimeCaptureStore.prototype, "getScheduleSLATime", null);
    __decorate([
        observable
    ], PreferredTimeCaptureStore.prototype, "isEnableResidentPreferredSchedule", void 0);
    __decorate([
        action
    ], PreferredTimeCaptureStore.prototype, "getIsEnableResidentPreferredSchedule", null);
    __decorate([
        observable
    ], PreferredTimeCaptureStore.prototype, "firstTimes", void 0);
    __decorate([
        observable
    ], PreferredTimeCaptureStore.prototype, "secondTimes", void 0);
    __decorate([
        observable
    ], PreferredTimeCaptureStore.prototype, "thirdTimes", void 0);
    __decorate([
        action
    ], PreferredTimeCaptureStore.prototype, "setTimes", null);
    __decorate([
        observable
    ], PreferredTimeCaptureStore.prototype, "isProvidePreferredScheduleTime", void 0);
    __decorate([
        observable
    ], PreferredTimeCaptureStore.prototype, "currentOptionId", void 0);
    __decorate([
        action
    ], PreferredTimeCaptureStore.prototype, "setOptions", null);
    __decorate([
        observable
    ], PreferredTimeCaptureStore.prototype, "isRequiredOptions", void 0);
    __decorate([
        observable
    ], PreferredTimeCaptureStore.prototype, "isRequired1st", void 0);
    __decorate([
        observable
    ], PreferredTimeCaptureStore.prototype, "isRequired2nd", void 0);
    __decorate([
        observable
    ], PreferredTimeCaptureStore.prototype, "isRequired3rd", void 0);
    __decorate([
        action
    ], PreferredTimeCaptureStore.prototype, "validate", null);
    __decorate([
        action
    ], PreferredTimeCaptureStore.prototype, "validateOptions", null);
    __decorate([
        action
    ], PreferredTimeCaptureStore.prototype, "validateFirstTimes", null);
    __decorate([
        action
    ], PreferredTimeCaptureStore.prototype, "validateSecondTimes", null);
    __decorate([
        action
    ], PreferredTimeCaptureStore.prototype, "validateThirdTimes", null);
    return PreferredTimeCaptureStore;
}());
export { PreferredTimeCaptureStore };
export default PreferredTimeCaptureStore;
export var TimesType;
(function (TimesType) {
    TimesType[TimesType["1st"] = 1] = "1st";
    TimesType[TimesType["2nd"] = 2] = "2nd";
    TimesType[TimesType["3rd"] = 3] = "3rd";
})(TimesType || (TimesType = {}));
